export default "__VITE_ASSET__a2e43f9e__"